export function conversations(_window, _document) {
  const arrowScroll = _document.getElementById("arrow-scroll")

  if (!arrowScroll) return

  arrowScroll.addEventListener("click", function (event) {
    const disableHeight = _document.documentElement.scrollHeight - 1000

    if (event.pageY < disableHeight) {
      const newMessageBox = _document.getElementById("new-message-box")
      if (newMessageBox) {
        const targetPosition = newMessageBox.offsetTop - 500
        _window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        })
      }
    }
  })
}
